import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

/** GET /addendum?pks_id=&type=&status=&search=&page=&limit= */
export async function getAddendums(queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL }).get("/addendum" + queryParams, {
    headers: extraHeaders,
  });
}

/** GET /addendum/:id */
export async function getAddendumById(id) {
  return await instance({ baseURL }).get(`/addendum/${id}`);
}

/** GET /addendum/pks/:pks_id — semua addendum milik satu PKS */
export async function getAddendumsByPKS(pks_id) {
  return await instance({ baseURL }).get(`/addendum/pks/${pks_id}`);
}

/** POST /addendum */
export async function createAddendum(body) {
  return await instance({ baseURL }).post(
    "/addendum",
    body,
  );
}

/** PUT /addendum/:id */
export async function updateAddendum(id, body) {
  return await instance({ baseURL }).put(
    `/addendum/${id}`,
    body,
  );
}

/** DELETE /addendum/:id */
export async function deleteAddendum(id) {
  return await instance({ baseURL }).delete(`/addendum/${id}`);
}

/** POST /addendum/:id/submit */
export async function submitAddendum(id) {
  return await instance({ baseURL }).post(`/addendum/${id}/submit`);
}

/** POST /addendum/:id/approve */
export async function approveAddendum(id) {
  return await instance({ baseURL }).post(`/addendum/${id}/approve`);
}

/** POST /addendum/:id/reject */
export async function rejectAddendum(id, body) {
  return await instance({ baseURL }).post(`/addendum/${id}/reject`, body);
}

/** POST /addendum/:id/activate */
export async function activateAddendum(id) {
  return await instance({ baseURL }).post(`/addendum/${id}/activate`);
}
